import { render, staticRenderFns } from "./SelectApps.html?vue&type=template&id=afc31ba2&scoped=true&"
import script from "./SelectApps.js?vue&type=script&lang=js&"
export * from "./SelectApps.js?vue&type=script&lang=js&"
import style0 from "./SelectApps.scss?vue&type=style&index=0&id=afc31ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc31ba2",
  null
  
)

export default component.exports